import { decodeConsulData } from './decodeConsulData'
import { getConsulData } from './getConsulData'
import { memoizeAsync } from '../utils/memoizeAsync'

const CONSUL_CACHE_TTL_MS = 60 * 1000

const getDecodedConsulDataCached = memoizeAsync(async (endpoint: string) => {
  const dataResponse = await getConsulData(endpoint)

  return decodeConsulData(dataResponse)
}, CONSUL_CACHE_TTL_MS)

export const getDecodedConsulData = async <T>(endpoint: string) => {
  const data = await getDecodedConsulDataCached(endpoint)

  return data as T
}
